import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, CanActivate } from '@angular/router';
import { Observable } from 'rxjs';
import { Configuracion } from '../entities/configuracion';
import { ConfiguracionService } from '../services/configuracion.service';

@Injectable({
  providedIn: 'root'
})
export class BrotherGuard implements  CanActivate{
  private config:Configuracion=null;
  constructor(private _configurationService:ConfiguracionService){}
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    return true;
  }
  async getConfiguration(){
    this.config = await this._configurationService.getConfiguracion();
    if(this.config.apphermano=="1"){
      return true;
    }
    return false;
  }
  
}
